exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".UIInventoryView table th,\n.UIInventoryView table td {\n  padding: 10px;\n  vertical-align: top;\n  text-align: left; }\n", ""]);

// exports
